import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="not-found-container">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  `,
  styles: [`
    .not-found-container {
      text-align: center;
      margin-top: 100px;
    }
  `]
})
export class NotFoundComponent {}
